import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { ScrollText } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-display text-lg font-800 text-secondary">{title}</h2>
    <div className="mt-2 space-y-2 text-sm leading-relaxed text-muted-foreground">{children}</div>
  </section>
);

export default function Legal() {
  return (
    <div className="App min-h-screen bg-background">
      <Header />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="legal-page">
        <div className="flex items-center gap-2 text-primary">
          <ScrollText className="h-5 w-5" />
          <span className="text-xs font-semibold uppercase tracking-wide">Informations légales</span>
        </div>
        <h1 className="mt-2 font-display text-4xl font-800 tracking-tight text-secondary">Mentions légales</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}
        </p>

        <Section title="Éditeur du site">
          <p>
            Le site et l'application <strong>PanierMoinsCher</strong> (comparateur de prix de courses,
            projet pilote en Île-de-France) sont édités par PanierMoinsCher.
          </p>
          <p>Forme juridique : à compléter · Capital social : à compléter</p>
          <p>Siège social : à compléter (France)</p>
          <p>SIREN / SIRET : à compléter · N° TVA intracommunautaire : à compléter</p>
          <p>Directeur de la publication : à compléter</p>
          <p>Contact : <a href="mailto:contact@paniermoinscher.fr" className="text-primary hover:underline">contact@paniermoinscher.fr</a></p>
        </Section>

        <Section title="Hébergement">
          <p>
            L'application est hébergée sur une infrastructure cloud sécurisée. Les coordonnées
            complètes de l'hébergeur peuvent être obtenues sur simple demande à l'adresse de contact
            ci-dessus.
          </p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des éléments de PanierMoinsCher (marque, logo, textes, interface, code) est
            protégé par le droit de la propriété intellectuelle. Toute reproduction ou réutilisation
            sans autorisation préalable est interdite.
          </p>
          <p>
            Les marques et noms des enseignes cités (E.Leclerc, Carrefour, Lidl, Auchan, Intermarché…)
            appartiennent à leurs propriétaires respectifs et sont mentionnés à des fins de comparaison
            de prix, sans lien de partenariat.
          </p>
        </Section>

        <Section title="Données de prix et sources">
          <p>
            Les prix affichés proviennent de données de démonstration et de sources publiques
            (Open Food Facts / Open Prices), et le cas échéant de fournisseurs de données tiers.
            Ils sont fournis à titre indicatif, datés et peuvent différer des prix réellement pratiqués
            en magasin. PanierMoinsCher ne saurait être tenu responsable d'un écart de prix.
          </p>
        </Section>

        <Section title="Données personnelles (RGPD)">
          <p>
            Les données que vous fournissez (email, nom, paniers, alertes) sont utilisées uniquement
            pour le fonctionnement du service. Conformément au RGPD, vous disposez d'un droit d'accès,
            de rectification et de suppression.
          </p>
          <p>
            Vous pouvez supprimer votre compte et l'intégralité de vos données à tout moment depuis le
            menu de votre compte (« Supprimer mon compte »), ou en écrivant à l'adresse de contact.
          </p>
        </Section>

        <Section title="Cookies et mesure d'audience">
          <p>
            Le site utilise des cookies strictement nécessaires (authentification) ainsi que des outils
            de mesure d'audience destinés à améliorer le service. Vous pouvez configurer votre navigateur
            pour refuser les cookies non essentiels.
          </p>
        </Section>

        <Section title="Paiements">
          <p>
            Les paiements de l'abonnement Premium sont traités de manière sécurisée par Stripe.
            PanierMoinsCher ne stocke aucune donnée de carte bancaire.
          </p>
        </Section>

        <Section title="Responsabilité">
          <p>
            PanierMoinsCher s'efforce de fournir des informations fiables mais ne garantit pas
            l'exactitude ou l'exhaustivité des prix et disponibilités. L'utilisation du service se fait
            sous votre seule responsabilité.
          </p>
        </Section>

        <div className="mt-10 border-t border-border pt-6 text-sm">
          <Link to="/" className="text-primary hover:underline" data-testid="legal-back-home">← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}
